const GRANTED = 'granted';
const DENIED = 'denied';

export const isNotificationSupported = () => {
  return 'Notification' in window;
};

export const isNotificationGranted = () => {
  if (isNotificationSupported()) return Notification.permission === GRANTED;
  return false;
};
export const isNotificationDenied = () => {
  if (isNotificationSupported()) return Notification.permission === DENIED;
  return false;
};

export const askNotificationPermission = () => {
  if (
    isNotificationSupported() &&
    !isNotificationGranted() &&
    !isNotificationDenied()
  )
    Notification.requestPermission();
};

const createNotification = ({ title, message, ...options }, onClick) => {
  const notification = new Notification(title, { body: message, ...options });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      notification.close();
    }
  });

  notification.addEventListener('click', (event) => {
    event.preventDefault();
    notification.close();
    window.parent.focus();
    if (onClick) {
      onClick(event);
    }
  });
  return notification;
};

export const notify = (content, onClick) => {
  if (!isNotificationSupported()) {
    console.log('This browser does not support desktop notification');
    return Promise.reject();
  }
  if (isNotificationDenied()) return Promise.reject();
  return Notification.requestPermission().then((permission) =>
    permission === GRANTED ? createNotification(content, onClick) : null
  );
};
